import React, { useState } from "react";
import "./style.css";

const ToggleButton = (props) => {
  let [localCheckedState, setLocalCheckedState] = useState(props.state);

  /**
   * Handles the change event for a checked state.
   * Toggles the local checked state and calls a callback function to update the parent component's state.
   *
   * @param {Event} e - The change event.
   */
  function handleCheckedStateChange(e) {
    setLocalCheckedState(!localCheckedState);
    props.toggleState(!localCheckedState);
  }

  /**
   * Handles the key press event to toggle the input when the Enter key is pressed.
   *
   * @param {Event} e - The key press event.
   */
  function handleKeyPress(e) {
    if (e.key === "Enter") {
      handleCheckedStateChange(e);
    }
  }

  return (
    <div className="toggle-button-container">
      <div className="toggle-button-container__wrapper">
        <label className="toggle-button-wrapper"
          tabIndex={-1}
          checked={localCheckedState}
          >
          <input
            tabIndex={0}
            type="checkbox"
            role="checkbox"
            onClick={handleCheckedStateChange}
            onKeyPress={handleKeyPress}
            aria-label={props.toggleButtonDescription}
            id="part-updates-toggle-button"
            className="toggle-button-wrapper__box"
          />
          <span className="toggle-button-wrapper__slider" tabIndex={-1}></span>
        </label>
        <div className="body-medium">{props.toggleButtonDescription}</div>
      </div>
    </div>
  );
};

export default ToggleButton;
